<template>
	<div class="display_wrapper">

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Ledger Opening Balance</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon @click="fn_edit">
		    	<v-icon>edit</v-icon>
		    </v-btn>

		    <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn>
		</v-toolbar>

		<div class="display hasToolbar">
			<div class="display_title">{{displayData.accountLedgerName}}</div>

			<v-list class="section-container" two-line>
		        <v-subheader light>Details</v-subheader>
		        <v-divider></v-divider>
		        <div>
		        	<v-list-tile>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Amount</v-list-tile-title>
			              	<v-list-tile-sub-title>&#8377; {{$root.numberToLocale(displayData.amount)}} {{$root.fn_payOrReceive(displayData.amountType, ledgerData.groupTypeId)}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
		        </div>

		    </v-list>

		   <!--  <v-list nopadding v-if="displayData.amount && onAccount">
			  	<v-list-tile>
			  		<v-list-tile-content>
			  			<v-list-tile-title>On Account</v-list-tile-title>
			  		</v-list-tile-content>
			  		<v-list-tile-action>&#8377; {{onAccount}}</v-list-tile-action>
			  	</v-list-tile>
			  	<v-divider></v-divider>
		   	</v-list> -->

		   	<!-- <v-list two-line nopadding margin-top-ten v-if="displayData.bwbItems && displayData.bwbItems.length">
		   	 	<v-subheader>Bill Wise Breakup</v-subheader>

			  	<v-divider></v-divider>

			    <div v-for="(item, index) in displayData.bwbItems" :key="index">
			  		<v-list-tile>
				  		<v-list-tile-content>
				  			<v-list-tile-title>{{item.refNumber}}</v-list-tile-title>
				  			<v-list-tile-sub-title>{{item.refDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
				  		</v-list-tile-content>
				  		<v-list-tile-action>
				  			&#8377; {{$root.numberToLocale(item.amount)}}
				  		</v-list-tile-action>
				  	</v-list-tile>

				  	<v-divider v-if="displayData.bwbItems.length-1 != index"></v-divider>
			  	</div>

		   	</v-list> -->

		</div>

		<dialog-confirmation ref="ref_dialogCancelDeleteTransaction" header="Delete Transaction?" confirmationMessage="Deleted transaction cannot be restored. Are you sure you want to delete this transaction?" :actionMethod="fn_callCancelTransaction" params="delete" :displayView='true' okBtnText="Yes" cancelBtnText="No" icon="warning" iconClass="redcolor" textClass="redcolor"></dialog-confirmation>

	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
const transactionForms = require('../../../../config.js').configs.transactionForms;
const transactionTypes = require('../../../../config.js').configs.transactionTypes;

import dialogConfirmation from '../../../dialogs/dialog_confirmation'
import {transactionMixin} from '../../transaction_mixin'

	export default{
		props:['settings'],
		mixins: [transactionMixin],
		data(){
			return{
				displayData:{"transactionId":null, "accountLedgerName":null, "amount":null, "amountType":null, "bwbItems":[]},
				ledgerData:null
				// saleTransactionListId: transactionTypes.bwbRefSaleInvoice.id,
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation
		},
		methods:{

			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_callCancelTransaction: function(paramObj){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;

				let self = this;
				this.fn_deleteTransaction(this.displayData.transactionId, this.displayData.transactionListId, function(status){
					if(status){
						self.showToast("Opening ledger of " + self.displayData.accountLedgerName + " has been deleted");
						self.$router.go(-1);
					}
					else{
						self.showToast("Something went wrong. Try again");
					}
				});
			},

			fn_get: function (itemId) {
				let filterObject = {};
				filterObject.type = this.settings.transactionTypeId;

				let self = this;
				this.getFilterData('Transaction', itemId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
				          	// let itemData = data.transactionLedgers[0];
				          	self.displayData.transactionId = data.transactionLedgers[0].transactionId;
				          	self.displayData.accountLedgerName = data.transactionLedgers[0].accountLedgerName;
				          	self.displayData.amount = data.transactionLedgers[0].amount;
				          	self.displayData.amountType = data.transactionLedgers[0].amountType;

				          	self.displayData.transactionListId = data.transactionListId;

				          	self.fn_getLedgerData(data.transactionLedgers[0].accountLedgerId)

				          	// self.displayData.bwbItems = data.bwbItems;
				          	self.$forceUpdate();
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getLedgerData: function(selectedValueId){
				let self = this;
				this.getData('Ledger', selectedValueId, 
					{
						onSuccess: function(response){
							console.log(response);

							self.ledgerData = JSON.parse(response);
							// !self.Form.transactionData.transactionId ? self.fn_showHideBwb() : self.fn_changeAmountType(self.Form.amountType);

				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Opening Ledger";
				viewObject.TopMenu = [menuItem.edit];
				viewObject.isBottomMenu = true;

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';

				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_getBottomMenu: function (tagId) {
				var bottomMenu = {"BottomMenu": [menuItem.delete]};
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit'){
					this.fn_edit();
				}
				else if(menuAction=='delete'){
					this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = true;
				}
			},

			fn_edit: function () {
				this.$router.push("/transactions/inventory/openingledger/items/"+this.displayData.transactionId+"/edit");
			}
		},
		mounted: function(){
			
			this.fn_showWebView();

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_onBackPress = this.fn_goBack;
			
			if(this.$route.params && this.$route.params.tagId){
				this.fn_get(this.$route.params.tagId);
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;
				next(false);
			}
			else{
				next(true);	
			}
	    },
		// computed:{
		// 	bwbTotal: function(){
		// 		let total = 0;
		// 		for(let i=0; i<this.displayData.bwbItems.length; i++){
		// 			total += this.displayData.bwbItems[i].amount
		// 		}
		// 		return total;
		// 	},
		// 	onAccount: function(){
		// 		if(this.bwbTotal){
		// 			return this.roundUpto2Decimals(this.displayData.amount - this.bwbTotal);
		// 		}
		// 		else{
		// 			return 0;
		// 		}
		// 	},
		// }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/opening_ledger/display.vue